import React from 'react';
import { useEffect, useRef, useState } from 'react';
import StyledSelect from '../../components/StyledSelect';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import useWindowSize from 'app/hooks/useWindowSize';
import HeaderDatePicker from 'app/pages/Catalog/components/Header';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectListPark } from 'app/pages/Home/slice/selectors';
import { CustomInput, listObject, listType } from '../helper';
import StyledButton from 'app/components/StyledButton';
import { Button, Input, Popover } from 'antd';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import { ReactComponent as CalendarIcon } from 'app/assets/img/icon_datepicker.svg';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow_down.svg';

import { CustomPopoverContent } from 'app/pages/Catalog/components/helper';
import * as _ from 'lodash';
import Tooltip from 'antd/es/tooltip';
const FilterHeaderComponent = (props: any) => {
  const {
    initFilter,
    translations,
    location,
    onClickSearch,
    listCatalogCustom,
    onChangeTab,
    valueTab,
    ticketTypeFilterContainer,
  } = props;
  const { device } = useWindowSize();
  const [paramsSearch, setParamsSearch] = useState(initFilter);
  const [listParkCustom, setListParkCustom] = useState<any>([]);
  const { locale } = useGlobalFunction();
  const filterPicker = useRef<HTMLDivElement>(null);

  const listPark = useSelector(selectListPark);
  const onChangeType = (valueType: any) => {
    setParamsSearch({
      ...paramsSearch,
      valueType: valueType,
    });
    if (device !== 'desktop') {
      onClickSearch({
        ...paramsSearch,
        valueType: valueType,
      });
    }
  };
  const onChangeObject = (valueAge: any) => {
    setParamsSearch({
      ...paramsSearch,
      ageType: valueAge,
    });
    if (device !== 'desktop') {
      onClickSearch({
        ...paramsSearch,
        ageType: valueAge,
      });
    }
  };
  const getValueTypeFilter = type => {
    let text = '';
    let textGroup: string[] = [];
    let arrGroup: any = [];
    if (type === 'filter') {
      const arrObject = listObject(translations).filter(item =>
        paramsSearch.ageType.includes(item.value),
      );
      const arrType = listType(translations).filter(item =>
        paramsSearch.valueType.includes(item.value),
      );
      arrGroup = [...arrObject, ...arrType];
    }
    if (
      type === 'park' &&
      listParkCustom.length > 0 &&
      !_.isEmpty(paramsSearch?.park)
    ) {
      const arrPark = listParkCustom.filter(item =>
        paramsSearch.park.includes(item.value),
      );
      arrGroup = [...arrPark];
    }
    textGroup = arrGroup.map((i: any) => i?.label);
    text = textGroup.toString();
    return text;
  };
  useEffect(() => {
    if (listPark?.length) {
      const listParkCustomTemp = listPark.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      const listParkId = _.isNull(initFilter?.park)
        ? listParkCustomTemp.map(item => item.value)
        : initFilter?.park;
      setParamsSearch(prev => ({
        ...prev,
        park: listParkId,
        groupCode: initFilter?.groupCode,
      }));
      setListParkCustom(listParkCustomTemp);
    }
  }, [initFilter?.groupCode, initFilter?.park, listPark]);

  const onChangePark = (checkedValues: any) => {
    // setParamsSearch({
    //   ...paramsSearch,
    //   park: checkedValues,
    // });
    // if (device !== 'desktop') {
    //   onClickSearch({
    //     ...paramsSearch,
    //     park: checkedValues,
    //   });
    // }
  };
  return (
    <>
      <div
        className="ticketHead d-flex"
        style={{ columnGap: device === 'desktop' ? '15px' : '8px' }}
      >
        {device === 'desktop' && (
          <>
            <div className="flex flex-col">
              <div className="txt-label">
                {translations ? translations['b2b.txt.ticketPark'] : ''}
              </div>
              <div className="d-flex align-items-center">
                {/* <StyledPopover
                  placement="bottomLeft"
                  content={
                    <div
                      className="popover-content"
                      style={{ minWidth: 130, margin: 4 }}
                    >
                      <div style={{ fontWeight: 600, marginBottom: 10 }}>
                        {translations
                          ? translations['b2b.text.sunworld-park']
                          : ''}
                      </div>
                      {CustomCheckBox(
                        listParkCustom,
                        paramsSearch?.park ?? [],
                        onChangePark,
                      )}
                    </div>
                  }
                  trigger="click"
                  overlayInnerStyle={{
                    borderRadius: '20px',
                  }}
                  getPopupContainer={() => filterPicker.current!}
                > */}
                <Button className="dropdown-filter">
                  <Tooltip
                    color="white"
                    overlayInnerStyle={{ color: 'black' }}
                    title={getValueTypeFilter('park')}
                  >
                    <Input
                      className="input-filter w-100"
                      value={getValueTypeFilter('park')}
                      readOnly
                      placeholder={
                        translations ? translations['b2c.txt.park'] : ''
                      }
                    />
                  </Tooltip>
                  {/* <img
                    src={Images.ArrowDownIcon}
                    style={{
                      filter: 'contrast(0)',
                    }}
                  /> */}
                </Button>
                {/* </StyledPopover> */}
              </div>
            </div>
            <div className="flex flex-col">
              <div className="txt-label">
                {translations ? translations['b2b.txt.group-ticket'] : ''}
              </div>
              <div className="d-flex align-items-center">
                <Tooltip
                  color="white"
                  overlayInnerStyle={{ color: 'black' }}
                  title={paramsSearch?.groupCode || ''}
                >
                  <Button className="dropdown-filter">
                    <Input
                      className="input-filter w-100"
                      value={paramsSearch?.groupCode || ''}
                      readOnly
                      placeholder={
                        translations ? translations['b2b.txt.group-ticket'] : ''
                      }
                    />
                  </Button>
                </Tooltip>
              </div>
            </div>
          </>
        )}
        {device !== 'desktop' && (
          <>
            <div className="flex flex-col w-100">
              <div className="box-order-label" style={{ fontWeight: 600 }}>
                {translations ? translations['b2b.txt.ticketPark'] : ''}
              </div>
              <Tooltip
                color="white"
                overlayInnerStyle={{ color: 'black' }}
                title={getValueTypeFilter('park')}
              >
                <div className="d-flex align-items-center mobile-box">
                  {getValueTypeFilter('park')}
                </div>
              </Tooltip>
            </div>
            {paramsSearch?.groupCode && (
              <div className="flex flex-col w-100">
                <div className="box-order-label" style={{ fontWeight: 600 }}>
                  {translations ? translations['b2b.txt.group-ticket'] : ''}
                </div>
                <Tooltip
                  color="white"
                  overlayInnerStyle={{ color: 'black' }}
                  title={paramsSearch?.groupCode}
                >
                  <div className="d-flex align-items-center mobile-box">
                    {paramsSearch?.groupCode || ''}
                  </div>
                </Tooltip>
              </div>
            )}
          </>
        )}
        {device !== 'desktop' && (
          <StyledSelect
            className="select-catalog-mobile"
            options={listCatalogCustom}
            onChange={onChangeTab}
            value={valueTab}
            suffixIcon={<ArrowDownIcon />}
            getPopupContainer={() => ticketTypeFilterContainer.current!}
            selectSelectionItemStyle={{ fontWeight: 700 }}
          />
        )}
        <div className="flex flex-col">
          <div className="txt-label">
            {translations ? translations['b2c.txt.filter'] : ''}
          </div>
          <PopupContainer ref={filterPicker} />
          <StyledPopover
            placement="bottomLeft"
            content={CustomPopoverContent(
              paramsSearch.valueType,
              onChangeType,
              paramsSearch.ageType,
              onChangeObject,
              listType(translations),
              listObject(translations),
            )}
            trigger="click"
            overlayInnerStyle={{
              borderRadius: '20px',
            }}
            getPopupContainer={() => filterPicker.current!}
          >
            <Tooltip
              color="white"
              overlayInnerStyle={{ color: 'black' }}
              title={device === 'desktop' ? getValueTypeFilter('filter') : ''}
            >
              <Button className="dropdown-filter">
                <Input
                  className="input-filter"
                  value={getValueTypeFilter('filter')}
                  readOnly
                  placeholder={
                    translations ? translations['b2c.txt.filter'] : ''
                  }
                />
                <img src="/static/img/icon_filter.svg" />
              </Button>
            </Tooltip>
          </StyledPopover>
        </div>

        <div className="flex flex-col btn-submit-search">
          <div className="txt-label"></div>
          <StyledButton
            onClick={() => onClickSearch(paramsSearch)}
            style={{
              background: '#FFFFFF',
              border: '1px solid #F8B117',
              color: '#F8B117',
              width: 124,
              maxWidth: 124,
              height: 44,
              flex: 1,
              bottom: 0,
            }}
          >
            {translations ? translations['b2c.txt.search'] : ''}
          </StyledButton>
        </div>
      </div>
    </>
  );
};
const PopupContainer = styled.div`
  & > div:first-child {
    z-index: 1;
  }
`;
const StyledPopover = styled(Popover)`
  .ant-popover-inner {
    background-color: lightblue !important;
  }
`;
export default FilterHeaderComponent;
